<template>
  <div class="question-bank">
    <el-breadcrumb separator=">">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>九科星题库</el-breadcrumb-item>
    </el-breadcrumb>
    <h1>九科星题库</h1>
    <div class="table-div clearfix" v-loading="loading">
      <table class="statistics-table-stage" cellspacing="0" cellpadding="0">
        <tr><td>学段</td></tr>
        <tr v-for="(item,index) of data" :key="index">
          <td :style="{  height: heights[index] + 'px' }">{{item.stageName}}</td>
        </tr>
        <!-- <tr><td class="">合计</td></tr> -->
      </table>
      <table class="statistics-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="head">学科</td>
        </tr>
        <template v-for="stage of data" >
          <tr v-for="(sub, subindex) of stage.subjectDtos" :key="subindex">
            <td class="subject" :style="{  height: sub.versionAndNumberDtos.length * 40 + 'px' }">{{sub.subjectName}}</td>
          </tr>
        </template>
        <!-- <tr><td></td></tr> -->
      </table>
      <table class="statistics-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="head">版本</td>
          <td class="head">数量</td>
        </tr>
        <template v-for="stage of data" >
          <template v-for="sub of stage.subjectDtos">
            <tr v-for="ver of sub.versionAndNumberDtos" :key="ver.versionName+ver.documentNumbers"><td>{{ver.versionName}}</td><td>{{ver.documentNumbers}}</td></tr>
          </template>
        </template>
        <!-- <tr>
          <td></td>
          <td>{{totaldocs}}</td>
        </tr> -->
      </table>
    </div>
  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'

export default {
  data: function () {
    return {
      heights: [],
      totaldocs: '',
      loading: false,
      data: []
    }
  },
  name: 'questionCenter',
  mounted () {
    this.getQuestionNum()
  },
  methods: {
    async getQuestionNum () {
      this.loading = true
      try {
        let resp = await commonService.getQuestionNum()
        this.data = resp.data.stageDto
        if (this.data && this.data.length > 0) {
          for (let item of this.data) {
            let length = 0
            for (let sub of item.subjectDtos) {
              length += sub.versionAndNumberDtos.length
            }
            this.heights.push(length * 40)
          }
        }
        this.totaldocs = resp.data.allDocumentNumbers
        this.loading = false
      } catch (e) {
        this.$message.error(e && e.msg)
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
</style>
<style>
  .question-bank{
    width: 1200px;
    margin: 0px auto;
    padding: 24px 0px;
  }
  .question-bank h1{
    width: 125px;
    margin: 40px auto 30px;
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color: #000000;
  }

  .question-bank .statistics-table-stage{
    border:1px solid #0096FF;
    background:linear-gradient(153deg,#1D3981,#00BF8F);
    width: 300px;
    text-align: center;
    font-size: 16px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-collapse:separate;
    color: #ffffff;
    font-weight: bold;
    float: left;
  }

  .question-bank .statistics-table-stage td{
    border-top: 0;
    border-bottom: 1px solid #ffffff;
    border-right: 0;
    border-left: 0;
  }

  .question-bank .statistics-table-stage .primary-school{
    height: 3480px;
  }

  .question-bank .statistics-table-stage .middle-school{
    height: 5200px;
  }

  .question-bank .statistics-table-stage .high-school{
    height: 2400px;
  }

  .question-bank .statistics-table-stage tr:last-child td {
    border-bottom: 0;
  }

  .question-bank .statistics-table-stage tr td{
    width: 300px;
    height: 40px;
  }

  .question-bank .statistics-table .head{
    font-weight:bold;
    color: #002488;
  }

  .question-bank .statistics-table tr td{
    width: 299px;
    height: 40px;
    font-weight:400;
    color:#666666;
  }

  .question-bank .statistics-table .subject{
    font-weight:bold;
    color:#333333;
  }

  .question-bank .statistics-table{
    border-top:1px solid #0096FF;
    border-right:1px solid #0096FF;
    border-bottom:1px solid #0096FF;
    /* width: 900px; */
    text-align: center;
    font-size: 16px;
    /* border-top-right-radius: 5px;
    border-bottom-right-radius: 5px; */
    border-collapse:separate;
    float: left;
  }

  .question-bank .statistics-table td {
    border-right: 1px solid #0096FF;
    border-bottom: 1px solid #0096FF;
    border-top: 0;
    border-left: 0;
  }

  .question-bank .statistics-table tr:last-child td {
    border-bottom: 0;
  }

  .question-bank .statistics-table .special {
    border-bottom: 0;
  }

  .question-bank .statistics-table tr td:last-child {
    border-right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/question-bank/index.vue